import { Box } from 'grid'
import { Icon, IIconProps } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTheme } from 'theme'

export type YesNoIconProps = Omit<IIconProps, 'iconName' | 'styles'> & {
  value?: boolean
}
export type YesIconProps = Omit<YesNoIconProps, 'value'>
export type NoIconProps = Omit<YesNoIconProps, 'value'>

export const YesIcon: React.FunctionComponent<YesIconProps> = (props) => {
  const theme = useTheme()
  return (
    <Icon
      iconName="CheckMark"
      styles={{ root: { color: theme.palette.greenDark } }}
      {...props}
    />
  )
}
export const NoIcon: React.FunctionComponent<NoIconProps> = (props) => {
  const theme = useTheme()
  return (
    <Icon
      {...props}
      iconName="Cancel"
      styles={{ root: { color: theme.palette.redDark } }}
    />
  )
}

export const YesNoIcon: React.FunctionComponent<YesNoIconProps> = ({
  value,
  ...props
}) => (value ? <YesIcon {...props} /> : <NoIcon {...props} />)

export const YesNothingIcon: React.FunctionComponent<YesNoIconProps> = ({
  value,
  ...props
}) => (value ? <YesIcon {...props} /> : <Box />)
